// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionWrapper_wrapper__dKwOd"};